import { Icon, Typography } from '@scale/scaleui';
import React from 'react';
import { FeedbackHelpfulness } from '@scale/shared/types/chat';
import { twMerge } from 'tailwind-merge';

export const BinaryFeedbackGroup: React.FC<{
  className?: string;
  helpfulness?: FeedbackHelpfulness;
  disabled?: boolean;
  message?: string;
  handleSubmitFeedback: (helpfulness: FeedbackHelpfulness) => void;
}> = ({
  className,
  helpfulness,
  disabled,
  message = '(Optional) Was this feedback helpful?',
  handleSubmitFeedback,
}) => {
  return (
    <div className={twMerge('flex pt-2 gap-2 items-center', className)}>
      <div>
        <Typography.Caption className="text-neutral-500">{message}</Typography.Caption>
      </div>
      <div className="flex gap-1 items-center">
        <Icon
          icon={[helpfulness === 'helpful' ? 'fas' : 'far', 'thumbs-up']}
          variant={helpfulness === 'helpful' ? 'secondary' : 'neutral'}
          className={helpfulness && helpfulness !== 'helpful' ? 'opacity-50' : ''}
          size="sm"
          onClick={e => {
            e.stopPropagation();
            handleSubmitFeedback('helpful');
          }}
          tooltip="Agree"
          tooltipProps={{
            side: 'top',
          }}
          disabled={disabled}
        />
        <Icon
          icon={[helpfulness === 'not_helpful' ? 'fas' : 'far', 'thumbs-down']}
          variant={helpfulness === 'not_helpful' ? 'secondary' : 'neutral'}
          className={helpfulness && helpfulness !== 'not_helpful' ? 'opacity-50' : ''}
          size="sm"
          onClick={e => {
            e.stopPropagation();
            handleSubmitFeedback('not_helpful');
          }}
          tooltip="Disagree"
          tooltipProps={{
            side: 'top',
          }}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
